import { FC, PropsWithChildren } from 'react';
import { Button } from '@mui/material';
import { Box } from '@ajorquera/libs/react';

interface Props extends PropsWithChildren {
  onClose?: () => void;
  close?: () => void;
}

const ConfirmationModal: FC<Props> = ({ children, onClose, close }) => {
  return (
    <>
      {children}
      <Box display="flex" justifyContent="end" mt={3}>
        <Button
          onClick={() => {
            onClose?.();
            close?.();
          }}
          variant="contained"
          color="primary"
        >
          OK
        </Button>
      </Box>
    </>
  );
};

export default ConfirmationModal;
